"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var RgbInput = /** @class */ (function (_super) {
    __extends(RgbInput, _super);
    function RgbInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (event, key) {
            var value = _this.props.value;
            value[key] = parseFloat(event.target.value);
            _this.setState({ value: value });
            _this.props.onChange(value);
        };
        return _this;
    }
    RgbInput.prototype.render = function () {
        var _this = this;
        var _a = this.props.value, r = _a.r, g = _a.g, b = _a.b, a = _a.a;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "label-row" },
                React.createElement("label", { className: "color-type-input-label" }, "R"),
                React.createElement("label", { className: "color-type-input-label" }, "G"),
                React.createElement("label", { className: "color-type-input-label" }, "B"),
                React.createElement("label", { className: "color-type-input-label" }, "A")),
            React.createElement("div", { className: "label-row" },
                React.createElement("input", { className: "multi-color-type-input", type: "number", value: r, onChange: function (event) { return _this.handleChange(event, 'r'); }, min: "1", max: "255" }),
                React.createElement("input", { className: "multi-color-type-input", type: "number", value: g, onChange: function (event) { return _this.handleChange(event, 'g'); }, min: "1", max: "255" }),
                React.createElement("input", { className: "multi-color-type-input", type: "number", value: b, onChange: function (event) { return _this.handleChange(event, 'b'); }, min: "1", max: "255" }),
                React.createElement("input", { className: "multi-color-type-input", type: "number", value: a, onChange: function (event) { return _this.handleChange(event, 'a'); }, step: "0.1", min: "0", max: "1" }))));
    };
    return RgbInput;
}(react_1.Component));
exports.default = RgbInput;
